module.exports = __webpack_public_path__ + "static/media/khipu.4c84d8fd.jpg";